module.exports = __webpack_public_path__ + "img/valores-fazer.f20f9d03.svg";